
import { useI18n } from "vue-i18n/index";

import { defineComponent, ref,onMounted,inject,provide,computed} from 'vue'

import { useRoute} from 'vue-router';

//components
import btnBack from "@/components/buttons/btnBack.vue"

//services
import eventService from "@/core/services/EventService";
import {
    errManager,
    dateParticipate,
    DownloadXLSXPDF,
    mbtoa
} from "@/core/config/Tools";

export default defineComponent({
    name: "acrd-manager",
    components: {
        btnBack,
    },
    setup() {
        const { t } = useI18n();
        const route = useRoute();
        //const store = useStore();
        const loader = ref(false)
        const evento = ref<any>({})
        provide("evento", evento)

        const { id } = route.params

        //detalle del evento
        const getDetails = async () => {
            loader.value = true
            await eventService.getDetails(`${id}?type=idevent&list=false`)
                .then((res) => {
                    evento.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }
        onMounted(() => {
            getDetails();
        })

        return {
            t,
            loader,
            id,
            evento,
            dateParticipate,
            mbtoa,
            //events
            getDetails,
            DownloadXLSXPDF

        }
    }

})
